/**
 * Footer — appears at the bottom of every page (below the fold).
 *
 * Even an MVP needs a footer: it signals legitimacy, holds the "how it works"
 * and support links, and is where policies live once we have them. Hidden
 * behind the mobile bottom nav's safe area with extra bottom padding.
 */

import { Link } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';

const LINK_GROUPS = [
  {
    heading: 'Rocket07',
    links: [
      { label: 'How it works', to: ROUTES.help },
      { label: 'Categories', to: ROUTES.categories },
      { label: 'Help & Support', to: ROUTES.help },
    ],
  },
  {
    heading: 'Account',
    links: [
      { label: 'My Orders', to: ROUTES.orders },
      { label: 'My Profile', to: ROUTES.profile },
      { label: 'Saved Addresses', to: ROUTES.addresses },
    ],
  },
];

export function Footer() {
  return (
    <footer className="mt-16 border-t border-line bg-surface pb-24 lg:pb-10">
      <div className="mx-auto max-w-6xl px-4 pt-10">
        <div className="grid grid-cols-2 gap-8 sm:grid-cols-4">
          {/* Brand blurb */}
          <div className="col-span-2">
            <div className="flex items-center gap-2">
              <span className="grid h-9 w-9 place-items-center rounded-xl bg-primary-500 text-lg font-black text-ink">
                R
              </span>
              <span className="text-xl font-extrabold tracking-tight text-ink">
                Rocket<span className="text-primary-600">07</span>
              </span>
            </div>
            <p className="mt-3 max-w-xs text-sm text-muted">
              Daily essentials delivered to your hostel in minutes. Built for campus, by campus.
            </p>
          </div>

          {LINK_GROUPS.map((group) => (
            <div key={group.heading}>
              <h4 className="text-sm font-semibold text-ink">{group.heading}</h4>
              <ul className="mt-3 space-y-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-sm text-muted hover:text-primary-600">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-line pt-6 text-xs text-muted sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Rocket07. Currently serving one campus.</p>
          <p>Made for students 💚</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
